"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCorporatePricingPolicySchema = exports.rejectCorporateAuthSchema = exports.enhanceCorporateAuthSchema = exports.approveCorporateAuthSchema = exports.requestCorporateAuthSchema = exports.ipCorporateCoverageReasonEnum = exports.ipCorporateAuthStatusEnum = void 0;
const zod_1 = require("zod");
/** IP corporate credit contracts — ADR-085 Phase 6. */
exports.ipCorporateAuthStatusEnum = zod_1.z.enum([
    'REQUESTED', 'PENDING', 'APPROVED', 'PARTIALLY_APPROVED', 'REJECTED', 'EXPIRED', 'CANCELLED',
]);
exports.ipCorporateCoverageReasonEnum = zod_1.z.enum([
    'AUTHORIZED_IN_FULL', 'AUTHORIZED_PARTIAL', 'CREDIT_LIMIT_EXCEEDED', 'AUTHORIZATION_REQUIRED',
    'AUTHORIZATION_REJECTED', 'AUTHORIZATION_EXPIRED', 'AGREEMENT_EXPIRED', 'CREDIT_ON_HOLD',
    'SERVICE_NOT_COVERED', 'NO_CORPORATE_ACCOUNT', 'REVERSAL',
]);
exports.requestCorporateAuthSchema = zod_1.z.object({
    corporateId: zod_1.z.string().uuid(),
    authorizationNumber: zod_1.z.string().min(1).max(40),
    requestedAmount: zod_1.z.number().int().positive(),
    employeeId: zod_1.z.string().max(60).optional(),
    externalReference: zod_1.z.string().max(100).optional(),
    validUntil: zod_1.z.coerce.date().optional(),
});
exports.approveCorporateAuthSchema = zod_1.z.object({
    approvedAmount: zod_1.z.number().int().positive(),
    approvedBy: zod_1.z.string().max(150).optional(),
    validUntil: zod_1.z.coerce.date().optional(),
});
exports.enhanceCorporateAuthSchema = zod_1.z.object({
    additionalAmount: zod_1.z.number().int().positive(),
    reason: zod_1.z.string().max(1000).optional(),
    approvedBy: zod_1.z.string().max(150).optional(),
});
exports.rejectCorporateAuthSchema = zod_1.z.object({ reason: zod_1.z.string().min(1).max(1000) });
/**
 * Corporate markup may be NEGATIVE — corporates routinely negotiate a discount
 * off list, which insurance never does. Bounded at -100% so a policy cannot
 * drive a price below zero.
 */
exports.createCorporatePricingPolicySchema = zod_1.z.object({
    corporateId: zod_1.z.string().uuid(),
    agreementId: zod_1.z.string().uuid().nullish(),
    baseTariffTier: zod_1.z.enum(['STANDARD', 'SEMI_PRIVATE', 'PRIVATE', 'DELUXE']).nullish(),
    markupBasisPoints: zod_1.z.number().int().min(-10_000).max(10_000),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().nullish(),
    notes: zod_1.z.string().max(1000).optional(),
});
//# sourceMappingURL=ip-corporate.schema.js.map